import { useCallback, useState } from '@wordpress/element';

export const useModal = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [editingField, setEditingField] = useState(null);

  const openModal = useCallback((area, field = null) => {
    setActiveModal(area);
    setEditingField(field);
  }, []);

  const closeModal = useCallback(() => {
    setActiveModal(null);
    setEditingField(null);
  }, []);

  return {
    activeModal,
    editingField,
    openModal,
    closeModal
  };
};